// START_MODULE pages_main_sections_announcements_announcements_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Render announcement content immediately without entrance animation while preserving its layout.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import AnnouncementItem from './components/annoucementItem/AnnouncementItem';

import { ContentSectionContainer } from 'components/layout/contentSectionContainer/ContentSectionContainer';

import { IAnnouncement } from 'domain/entities/IAnnouncement';

import { Section } from 'routes/section';

interface AnnouncementsProps {
  announcements: IAnnouncement[];
}

const Announcements: React.FC<AnnouncementsProps> = ({ announcements }) => (
  <ContentSectionContainer id={Section.ANNOUNCEMENTS} type="middle">
    <h4>Анонсы</h4>
    {
      announcements.map((announcement) => (
        <div key={announcement.id}>
          <AnnouncementItem announcement={announcement} />
        </div>
      ))
    }
  </ContentSectionContainer>
);

export default Announcements;

// END_MODULE pages_main_sections_announcements_announcements_tsx
